import { render, staticRenderFns } from "./MenuItemsForm.vue?vue&type=template&id=204ba69c"
import script from "./MenuItemsForm.vue?vue&type=script&lang=js"
export * from "./MenuItemsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports